import { Box, styled, Table } from "@mui/material";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Scrollbar from "components/ScrollBar";
import {
  useExpanded,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";

const DefaultStyledTableRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: 12,
}));

const DefaultHeadTableCell = styled(TableCell)(({ theme }) => ({
  padding: "5px 8px",
  fontSize: 12,
  fontWeight: 600,
  color: theme.palette.text.secondary,
}));

const DefaultBodyTableCell = styled(DefaultHeadTableCell)(({ theme }) => ({
  color: theme.palette.text.primary,
  padding: "12px 8px",
  "&:first-of-type": {
    paddingLeft: 16,
  },
  "&:last-child": {
    paddingRight: 16,
  },
}));

function DefaultDataTable({ data, columns }) {
  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, page } =
    useTable(
      {
        columns,
        data,
        manualPagination: true,
      },
      useSortBy,
      useExpanded,
      usePagination,
      useRowSelect
    );

  return (
    <Box>
      <Scrollbar autoHide={false}>
        <Table
          {...getTableProps()}
          sx={{
            borderSpacing: "0 1rem",
            borderCollapse: "separate",
            minWidth: 900,
          }}
        >
          <TableHead>
            {headerGroups.map((headerGroup, key) => (
              <TableRow key={key} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <DefaultHeadTableCell
                    key={index}
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                  >
                    {column.render("Header")}
                  </DefaultHeadTableCell>
                ))}
              </TableRow>
            ))}
          </TableHead>

          <TableBody {...getTableBodyProps()}>
            {page.map((row, index) => {
              prepareRow(row);
              return (
                <DefaultStyledTableRow
                  key={index}
                  {...row.getRowProps()}
                  sx={{
                    cursor: "pointer",
                  }}
                >
                  {row.cells.map((cell, index) => (
                    <DefaultBodyTableCell key={index} {...cell.getCellProps()}>
                      {cell.render("Cell")}
                    </DefaultBodyTableCell>
                  ))}
                </DefaultStyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </Scrollbar>
    </Box>
  );
}

const OutlineStyledTableRow = styled(TableRow)(({ theme }) => ({}));

const OutlineHeadTableCell = styled(TableCell)(({ theme }) => ({
  padding: "4px 10px",
  fontSize: 12,
  fontWeight: 600,
  color: theme.palette.text.secondary,
}));

const OutlineBodyTableCell = styled(OutlineHeadTableCell)(({ theme }) => ({
  color: theme.palette.text.primary,
}));

function OutlineDataTable({ data, columns }) {
  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, page } =
    useTable(
      {
        columns,
        data,
        manualPagination: true,
      },
      useSortBy,
      useExpanded,
      usePagination,
      useRowSelect
    );

  return (
    <Box>
      <Scrollbar autoHide={false}>
        <Table
          {...getTableProps()}
          sx={
            {
              // borderSpacing: "0 1rem",
              // borderCollapse: "separate",
              // minWidth: 900,
            }
          }
        >
          <TableHead>
            {headerGroups.map((headerGroup, key) => (
              <TableRow key={key} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <OutlineHeadTableCell
                    key={index}
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                  >
                    {column.render("Header")}
                  </OutlineHeadTableCell>
                ))}
              </TableRow>
            ))}
          </TableHead>

          <TableBody {...getTableBodyProps()}>
            {page.map((row, index) => {
              prepareRow(row);
              return (
                <OutlineStyledTableRow
                  key={index}
                  {...row.getRowProps()}
                  sx={{
                    cursor: "pointer",
                  }}
                >
                  {row.cells.map((cell, index) => (
                    <OutlineBodyTableCell key={index} {...cell.getCellProps()}>
                      {cell.render("Cell")}
                    </OutlineBodyTableCell>
                  ))}
                </OutlineStyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </Scrollbar>
    </Box>
  );
}

export { DefaultDataTable, OutlineDataTable };
